import {Image} from 'src/design/atoms/Image';
import type {ImageProps} from 'src/design/atoms/Image';
import React from 'react';
import {useAppSelector} from 'src/redux/hooks';
import {getUrlWithEncodingAndAuth} from 'src/shared/utils/urlHelpers';

export interface ProtectedImageProps extends Omit<ImageProps, 'src'> {
  src: string;
  alt?: string;
}

/**
 * ProtectedImage component that extends Mantine's Image component
 * with automatic authentication and URL encoding for protected resources.
 */
export const ProtectedImage = React.memo<ProtectedImageProps>(
  ({src, alt, ...props}) => {
    const {accessToken} = useAppSelector(state => state.auth);

    const authenticatedSrc = getUrlWithEncodingAndAuth(src, accessToken);

    return <Image {...props} src={authenticatedSrc} alt={alt} />;
  }
);
